import { legacyOauthApps } from '../legacyOauthApps';
export const isLegacyInstallerFlow = (appId, experiments) => {
  const isShipreadygoInOldInstaller = Boolean(experiments == null ? void 0 : experiments.enabled('spec.dcc.isShipreadygoInOldInstaller'));
  return legacyOauthApps(isShipreadygoInOldInstaller).includes(appId);
};
//# sourceMappingURL=is-legacy-installer-flow.js.map